
export default {
  methods: {
    errorHandler (error) {
      return error.networkError ?? error.message
    }
  }
}
